export * from './post-hochladen.component';
export * from './post-hochladen.component.module';